export enum EAuthQueryKey {}
